import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

constructor(private http:HttpClient) { }


  GetRecord():Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl+ "Daro/Calendar").pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  Add(geoDate: string,dsc:string):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      token:'',
      geoDate:geoDate,
      dsc:dsc,
      id:0
    }


      return this.http.post(environment.BaseUrl + "Daro/Calendar/Add",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
      )

  }

  Delete(id:number):Observable<any>{
    return this.http.get(environment.BaseUrl+ "Daro/Calendar/Delete?id="+id).pipe(
      map(data=>{
        return data as any
      })
    )
  }


}
